<template>
  <div class="activity-center-feature-tabs">
    <span class="activity-center-feature-tabs__label">Features</span>

    <div class="activity-center-feature-tabs__buttons">
      <mi-button
        v-for="tab in tabs"
        :key="tab.name"
        class="activity-center-feature-tabs__btn"
        :class="{ 'activity-center-feature-tabs__btn--active': modelValue === tab.name }"
        @click="$emit('update:modelValue', tab.name)"
      >
        {{ tab.label }} ({{ tab.count }})
      </mi-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ActivityCenterFeatureTabs',
    props: {
      modelValue: {
        type: String,
        required: true
      },
      tabs: {
        type: Array,
        required: true
      }
    },
    emits: ['update:modelValue']
  }
</script>

<style lang="scss" scoped>
  .activity-center-feature-tabs {
    padding: 0 24px 18px;
    background-color: $mi-white;

    &__label {
      display: block;
      margin-bottom: 8px;
      font-family: $mi-typography-font-family-condensed;
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: $mi-anthracite-800;
    }

    &__buttons {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
    }

    &__btn {
      padding: 8px 14px;
      border: 1px solid $mi-silver-300;
      border-radius: 4px;
      background-color: $mi-white;
      cursor: pointer;
      font-family: $mi-typography-font-family-condensed;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: $mi-anthracite-800;

      &:hover {
        background-color: $mi-silver-50;
      }

      &--active {
        background-color: $mi-anthracite-900;
        border-color: $mi-anthracite-900;
        color: $mi-white;

        &:hover {
          background-color: $mi-anthracite-900;
        }
      }
    }
  }
</style>
